// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DCSBoardV2_wrapper__Dvlxh","btn":"DCSBoardV2_btn__1812S"};